var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col action-wrap"},[_c('button',{staticClass:"button button--solid",on:{"click":_vm.submitForm}},[_vm._v("Submit")])])])}
var staticRenderFns = []

export { render, staticRenderFns }